import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const modulePlacements = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    buffers: {},
    responses: {}
  }
};

export default modulePlacements;
